import Sidebar from './Sidebar';
import List from './List';

export { Sidebar, List };



// WEBPACK FOOTER //
// ./src/components/ProductsPage/components/index.js